import { EnvironmentConfigItem } from "./models/environment-config.model";
import { EnvironmentNames } from "./models/environment-names.enum";

export function getEnvironments(...environmentKey: EnvironmentNames[]): EnvironmentConfigItem[] {
  return environmentConfigItems.filter(x => environmentKey.find(key => x.envKey == key));
}
export function getEnvironment(environmentKey: EnvironmentNames): EnvironmentConfigItem {
  return environmentConfigItems.find(x => x.envKey == environmentKey);
}

export const environmentConfigItems: EnvironmentConfigItem[] = [
  {
    envKey: EnvironmentNames.enterprise,
    envMessage: 'Ent - Local',
    environmentLabel: 'LOCAL',
    environmentEmoji: '🟢',
    apiRoot: "https://localhost:44368/api/v1",
    useCDN: true,
    cdnRoot: 'https://fitness-challenge-test.b-cdn.net/api/v1',
  },
  {
    envKey: EnvironmentNames.local,
    envMessage: 'Local',
    environmentLabel: 'LOCAL',
    environmentEmoji: '🟢',
    apiRoot: "https://localhost:57525/api/v1",
    useCDN: true,
    cdnRoot: 'https://fitness-challenge-test.b-cdn.net/api/v1',
  },
  {
    envKey: EnvironmentNames.test,
    envMessage: 'Test',
    environmentLabel: 'TEST',
    environmentEmoji: '🟠',
    hostNameMatch: 'fitness-challenge-test.azurewebsites.net',
    apiRoot: "https://fitness-challenge-test-api.azurewebsites.net/api/v1",
    useCDN: true,
    cdnRoot: 'https://fitness-challenge-test.b-cdn.net/api/v1',
  },
  {
    envKey: EnvironmentNames.releaseCandidate,
    envMessage: 'Release Candidate',
    hostNameMatch: 'rc.holidaystreakers.com',
    apiRoot: "https://fitness-challenge-api.azurewebsites.net/api/v1",
    useCDN: true,
    cdnRoot: 'https://cdn.holidaystreakers.com/api/v1',
  },
  {
    envKey: EnvironmentNames.staging,
    envMessage: 'Staging',
    environmentLabel: 'STAGING',
    environmentEmoji: '🟠',
    hostNameMatch: 'staging.holidaystreakers.com',
    apiRoot: 'https://fitness-challenge-api-staging.azurewebsites.net/api/v1',
    useCDN: true,
    cdnRoot: 'https://cdn.holidaystreakers.com/api/v1',
  },
  {
    envKey: EnvironmentNames.prod,
    envMessage: '',
    hostNameMatch: 'app.holidaystreakers.com',
    apiRoot: "https://fitness-challenge-api.azurewebsites.net/api/v1",
    useCDN: true,
    cdnRoot: 'https://cdn.holidaystreakers.com/api/v1',
  },
];

// Promote the same build unchanged; hostnames stay with their Azure slots.
export function getProductionEnvironment(hostname: string): EnvironmentConfigItem {
  const host = (hostname || '').toLowerCase();
  const isStaging = host === 'staging.holidaystreakers.com'
    || host === 'fitness-challenge-prod-staging.azurewebsites.net';
  return getEnvironment(isStaging ? EnvironmentNames.staging : EnvironmentNames.prod);
}
